module.exports = __webpack_public_path__ + "static/media/marker.27626bb9.svg";